const setColorsProperties = (colors: any) => {
  Object.keys(colors).forEach((color) => {
    document.documentElement.style.setProperty(`--${color}`, colors[color]);
  });
};

export default setColorsProperties;
